import { Injectable } from '@angular/core';

@Injectable()
export class AppConfigValues {
    //public apiHostUrl: string = 'http://localhost:55706/'; // local development settings
    //public apiHostUrl: string = ''; // production settings

      public getApiHostUrl(): string{
        //console.log("process.env.ENV" + process.env.ENV);
        if (process.env.ENV === 'production') {
             return '/taf2025/';
            //  return '/tafpiv/';
            //  return '/tafregionalreview/'; // production settings
             //return '/tafl/'; // production settings
        }else{
               return 'http://localhost:55706/'; // local development settings
        } 
    }
    
}


/** WEBPACK FOOTER **
 ** ./app/shared/app-config-values.ts
 **/